import { AccountTokenServant } from '../servants/account_token_servant';
import * as _4 from 'lodash4';
const AccountIdentityDatastoreDTD = {
  id: 'integer',
  username: 'string',
  email: 'email',
  token: 'string',
  tracking_id: 'string',
  gainsight_id: 'string',
  account_type: 'string',
  account_name: 'string',
  first_name: 'string', // firstName
  last_name: 'string', // lastName
  student_nk: 'string',
  partner_nk: 'string',
  student_id: 'integer',
  channel_name: 'string',
  permissions: 'array',
  is_instructor: 'boolean',
  fullname: {
    optional: true,
    type: 'string'
  },
  emailUsername: {
    optional: true,
    type: 'string'
  },
  initials: {
    optional: true,
    type: 'string'
  },
  group_names: 'array'
};

export interface IAccountIdentityDatastore
  extends Record<keyof typeof AccountIdentityDatastoreDTD, string | Record<string, string>> {}
export class AccountIdentityDatastore {
  private id: string;
  public store: IAccountIdentityDatastore;
  constructor(private Interface: any) {
    this.id = 'account-identity';
    this.initialize();
    this.clear();
  }

  update(data: any) {
    this.store = this.Interface.make(AccountIdentityDatastoreDTD, data);
    this.store = this.calculateNewProperties(this.sanitizeProperties(this.store));
    return this;
  }

  updateWithValidToken(accountToken: { userdata: any }) {
    if (AccountTokenServant.isUserAlreadyLoggedIn(accountToken)) {
      this.update(accountToken);
    }
  }

  initialize() {
    this.store = this.Interface.generate(AccountIdentityDatastoreDTD);
    this.store = this.calculateNewProperties(this.sanitizeProperties(this.store));
    return this;
  }

  read(
    fn: (
      store: IAccountIdentityDatastore
    ) => IAccountIdentityDatastore | IAccountIdentityDatastore[keyof IAccountIdentityDatastore]
  ) {
    return fn(this.store);
  }

  externalize() {
    return this.Interface.serialize(AccountIdentityDatastoreDTD, this.store);
  }
  clear() {
    this.store = {} as IAccountIdentityDatastore;
  }

  sanitizeProperties(store: any) {
    store.firstName = store.first_name = _4.trim(store.first_name);
    store.lastName = store.last_name = _4.trim(store.last_name);
    return store;
  }

  calculateNewProperties(store: any) {
    const NO_INITIALS = ':)';
    const emailAddress = store.username.indexOf('@') !== -1 ? store.username : store.email;

    // ['si-umich', 'navigate', 'eab', 'com']
    // ['localhost']
    //
    const [partnerNK] = new URL(location.href).hostname.split('.');

    store.partner_nk = partnerNK;
    store.fullname = `${store.firstName} ${store.lastName}`;
    store.emailUsername = emailAddress.slice(0, emailAddress.indexOf('@'));
    store.initials =
      !_4.isEmpty(store.firstName) && !_4.isEmpty(store.lastName)
        ? _4.capitalize(_4.first(store.firstName)) + _4.capitalize(_4.first(store.lastName))
        : NO_INITIALS;

    return store;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/datastore/account_identity_datastore.ts